import { Check } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Planos() {
  const planos = [
    {
      nome: "Mensal",
      preco: "130,00",
      periodo: "mês",
      economia: null,
      destaque: false,
      features: [
        "Alunos Ilimitados",
        "Turmas Ilimitadas",
        "Gestão Completa de Mensalidades",
        "Relatórios (PDF/Excel)",
        "Controle de Chamada",
        "Upload de Fotos",
        "Logins Auxiliares",
        "Contrato Digital"
      ]
    },
    {
      nome: "Semestral",
      preco: "110,00",
      periodo: "mês",
      economia: "Economize R$ 120,00",
      destaque: true,
      precoTotal: "R$ 660,00 a cada 6 meses",
      features: [
        "Alunos Ilimitados",
        "Turmas Ilimitadas",
        "Gestão Completa de Mensalidades",
        "Relatórios (PDF/Excel)",
        "Controle de Chamada",
        "Upload de Fotos",
        "Logins Auxiliares",
        "Contrato Digital",
        "✨ 15% de desconto"
      ]
    },
    {
      nome: "Anual",
      preco: "90,00",
      periodo: "mês",
      economia: "Economize R$ 480,00",
      destaque: false,
      precoTotal: "R$ 1.080,00 por ano",
      features: [
        "Alunos Ilimitados",
        "Turmas Ilimitadas",
        "Gestão Completa de Mensalidades",
        "Relatórios (PDF/Excel)",
        "Controle de Chamada",
        "Upload de Fotos",
        "Logins Auxiliares",
        "Contrato Digital",
        "✨ 31% de desconto",
        "🎁 2 meses grátis"
      ]
    }
  ];

  const handleContato = () => {
    window.open('https://wa.me/5562996379383?text=Olá! Gostaria de assinar o GEE', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-4" style={{ fontFamily: 'Space Grotesk' }}>
            Planos e Preços
          </h1>
          <p className="text-xl text-gray-600 mb-2">
            Escolha o melhor plano para sua escola esportiva
          </p>
          <p className="text-lg text-gray-500">
            Todas as funcionalidades em todos os planos
          </p>
        </div>

        {/* Cards de Planos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {planos.map((plano, index) => (
            <Card 
              key={index}
              className={`relative ${
                plano.destaque 
                  ? 'border-4 border-blue-500 shadow-2xl scale-105 z-10' 
                  : 'border-2'
              }`}
            >
              {plano.destaque && (
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2">
                  <span className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                    🔥 MAIS POPULAR
                  </span>
                </div>
              )}
              
              <CardHeader className="text-center pt-8">
                <CardTitle className="text-3xl mb-2">{plano.nome}</CardTitle>
                {plano.economia && (
                  <div className="bg-green-100 text-green-700 text-sm font-semibold py-1 px-3 rounded-full inline-block mb-4">
                    {plano.economia}
                  </div>
                )}
                <div className="mb-4">
                  <span className="text-5xl font-bold">R$ {plano.preco}</span>
                  <span className="text-gray-600">/{plano.periodo}</span>
                </div>
                {plano.precoTotal && (
                  <CardDescription className="text-base font-medium">
                    {plano.precoTotal}
                  </CardDescription>
                )}
              </CardHeader>

              <CardContent>
                <ul className="space-y-3 mb-8">
                  {plano.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button 
                  onClick={handleContato}
                  className={`w-full py-6 text-lg font-semibold ${
                    plano.destaque
                      ? 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700'
                      : 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700'
                  }`}
                >
                  Assinar Agora
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Seção de Contato */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-12 text-center text-white shadow-xl">
          <h2 className="text-3xl font-bold mb-4">
            Dúvidas sobre qual plano escolher?
          </h2>
          <p className="text-xl mb-6 opacity-90">
            Entre em contato e nossa equipe te ajudará a escolher o melhor plano
          </p>
          <Button
            onClick={handleContato}
            size="lg"
            className="bg-white text-blue-600 hover:bg-gray-100 text-lg px-8 py-6 font-semibold"
          >
            📱 WhatsApp: (62) 99637-9383
          </Button>
        </div>

        {/* FAQ Rápido */}
        <div className="mt-16 max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-center mb-8">Perguntas Frequentes</h3>
          <div className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Posso mudar de plano depois?</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">
                  Sim! Você pode fazer upgrade ou downgrade do seu plano a qualquer momento entrando em contato conosco.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Há limite de alunos ou turmas?</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">
                  Não! Todos os planos incluem alunos e turmas ilimitadas.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Como funciona o pagamento?</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">
                  Entre em contato via WhatsApp e nossa equipe irá te orientar sobre as formas de pagamento disponíveis.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
